import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 347 105.5"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m347 75.6-3.2 14.9s-.9 6.7-5.7 9.2c-4.7 2.5-12.5 2.4-12.5 2.4h-83.7l5-23.4c-8.3 18.2-29.9 26.8-68.2 26.8s-37.8-1.6-48.4-9.7l1.3 6.2H90.2l-1.7-11.3H47.9L41.3 102H0l54.5-85.4s5.4-8.8 9.6-10.9c4.8-2.4 13.6-2.3 13.6-2.3h33.1l14.7 68.9h44.6c-.6 3.3.2 5.5 2.6 7 2.6 1.4 6.7 2.1 12.8 2.1 12.2 0 16.2-3.3 17.2-8 .6-2.9-.6-5.8-5.6-6.6L154 60.2c-18.4-2.9-24-14-21-27.8C138.4 6.9 164.8 0 196.9 0s59.6 11.5 56.5 32.3h-45.3c.9-4-1-6.5-4.3-7.9-3.1-1.5-7.4-2.1-11.7-2.1-11.6 0-16.2 2.9-17.1 7-.6 2.8.3 4.6 4 5.1l45.1 6.9c15.9 2.4 25.6 9.2 26.3 21.2L263 3.4h39l-15.3 72.1H347ZM105.6 52.2S92.8 46.1 77.2 47c-23.6 1.4-31.7 16.1-31.7 16.1s10-7 28.3-6.1c12.7.6 20 5.3 20 5.3s1.7-5.3 4.7-7.5 7.1-2.6 7.1-2.6",
      style: {"fill":"#00539b"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "5O-logo"}) } }